// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getFormattedCountries } from '@/ts-helpers/campaign.helpers';
import DownloadSubHeaderBase from './DownloadSubHeaderBase';

function DownloadSubHeaderMulti() {
  const { formatMessage } = useIntl();

  const campaigns = useSelector(getSelectedCampaigns);
  const campaingsCount = campaigns.length;

  const title = formatMessage(
    {
      defaultMessage: `${campaingsCount} Campaigns Selected`,
      id: 'reporting.header.multi.details.campaignsSelected'
    },
    {
      count: campaingsCount
    }
  );

  return (
    <DownloadSubHeaderBase
      fields={[
        {
          name: formatMessage({
            defaultMessage: 'Country:',
            id: 'reporting.header.multi.details.country'
          }),
          value: getFormattedCountries(campaigns).join(', ')
        }
      ]}
      title={title}
    />
  );
}

export default DownloadSubHeaderMulti;
